// Central place to store denormalized 
// Docs: https://harperjames.atlassian.net/wiki/spaces/I/pages/1099005953/Denormalised+data


/** 
 * helper function to get copy of an object with subset of properties
 */
function cloneSubsetOfObject(object, props) {
  return Object.fromEntries(Object.entries(object).filter(([key]) => props.includes(key)))
}

function getDenormalizedObject(object, objectId, props) {
  const result = cloneSubsetOfObject(object, props)
  result.id = objectId
  return result
}

/**
 * Returns a denormalised user (workforce) object
 * @param {*} userObject from firebase workforce
 */
export const workforce = (object, objectId = object.id) => {
  const props = ['firstName', 'lastName', 'email']
  return getDenormalizedObject(object, objectId, props)
}

export const project = (object, objectId = object.id) => {
  const props = ['name', 'owners']
  return getDenormalizedObject(object, objectId, props)
}

export const location = (object, objectId = object.id) => {
  const props = ['name']
  return getDenormalizedObject(object, objectId, props)
}


export default {
  workforce,
  project,
  location
}